import EditIcon from "@mui/icons-material/Edit"
import { Box, CircularProgress, DialogContentText, MenuItem } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { useFormik } from "formik"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import simulatorApplicationService from "services/simulatorApplicationService"
import { updateSimulatorApplication } from "slices/simulatorApplicationSlice"
import type {
  ISimulatorApplication,
  IUpdateSimulatorApplication,
} from "types/simulatorApplicationTypes"
import * as Yup from "yup"

type Props = {
  app: ISimulatorApplication
}

export function UpdateSimulatorApplicationDialog({ app }: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)

  const dispatch = useAppDispatch()

  const initialValues: IUpdateSimulatorApplication = {
    name: app.name,
  }

  const updatesimulatorApplicationValidationScheme = Yup.object({
    name: Yup.string()
      .required("Please enter name")
      .max(64, "Maximum name length is 64 characters"),
  })

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: updatesimulatorApplicationValidationScheme,
    onSubmit: (values) => {
      setIsLoading(true)

      const simulatorApplicationUpdate: IUpdateSimulatorApplication = {
        name: values.name,
      }

      simulatorApplicationService
        .updateSimulatorApplication(app.id, simulatorApplicationUpdate)
        .then((resp) => {
          dispatch(updateSimulatorApplication(resp))
          setIsLoading(false)
          handleClose()
        })
        .catch((err) => {
          console.log(err)
          setIsLoading(false)
        })
    },
  })

  const handleClickOpen = () => {
    formik.resetForm()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <EditIcon sx={{ marginRight: 1 }} />
        Update
      </MenuItem>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>Update Simulator Application</DialogTitle>
          <DialogContent>
            <DialogContentText>Please enter name for the application.</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="name"
              fullWidth
              variant="outlined"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button type="submit" disabled={isLoading}>
                Update
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
